module.exports = __webpack_public_path__ + "img/按钮_箭头向左_o.ba26611f.png";